import React from 'react';
import { Image, Text } from '@zillow/constellation';
import * as S from './styles';

import type Comparables from '../models/Comparables';

export interface ListingCardProps {
  listing: Comparables;
}
const ListingCard: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<ListingCardProps>>> = ({
  listing,
}) => {
  const { propertyPhotos, bubblePrice, pricePerSqft, beds, baths, sqft, url, isActive } = listing;
  const propertyPhoto = propertyPhotos && propertyPhotos[0] && propertyPhotos[0].medium;
  return (
    <S.Card cardType="secondary">
      <S.PhotoContainer>
        <Image src={propertyPhoto} alt="property photo" height="69px" width="69px" />
      </S.PhotoContainer>
      <S.Details paddingLeft="xs">
        <Text fontType="h5" as={isActive ? 'a' : null} href={isActive ? url : null} target="_blank">
          {bubblePrice}/mo
        </Text>
        {pricePerSqft && <Text fontType="bodySmall">{pricePerSqft} per sq ft</Text>}
        <Text fontType="bodySmall">
          {beds ? beds : '--'} bd, {baths ? baths : '--'} ba, {sqft ? sqft : '--'} sqft
        </Text>
      </S.Details>
    </S.Card>
  );
};

export default ListingCard;
